// src/components/VendorCard.js
import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { FaHeart, FaRegHeart, FaStar } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import './vendor_card.css';
import { useNavigate } from 'react-router-dom';

const VendorCard = ({ vendor, isInWishlist, onWishlistToggle }) => {
  const navigate = useNavigate();
  const {
    business_name = "Vendor Name",
    city = "Location, City",
    business_category = "Category",
    business_photos,
    rating = 4.8,
    reviews = 89,
    price = 60000
  } = vendor;

  const image = business_photos?.[0] || 'https://via.placeholder.com/400x250';
  const handleWishlistClick = (e) => {
    e.stopPropagation();

    if (onWishlistToggle) {
      onWishlistToggle(vendor);
    }
  };

  return (
    <Card className="vendor-card shadow-sm border-0" style={{ height: "max-content" }} onClick={() => navigate(`/vendor/${vendor.id}`)}>
      <div className="card-img-container">
        <Card.Img variant="top" src={image} className="vendor-image" />
        <div className="card-img-overlay d-flex flex-column p-2">
          <div
            className={`icon-badge heart-badge ${isInWishlist ? 'active' : ''}`}
            onClick={handleWishlistClick}
          >
            {isInWishlist ? <FaHeart color='red' /> : <FaRegHeart />}
          </div>
        </div>
      </div>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <Card.Title className="vendor-title mb-0">{business_name}</Card.Title>
          <div className="rating-display d-flex align-items-center">
            <FaStar color="#ffc107" className="me-1" />
            <span className="rating-number"><strong>{rating.toFixed(1)}</strong></span>
            <span className="text-muted review-count"> ({reviews} reviews)</span>
          </div>
        </div>
        <Card.Text className="mb-1 p-0" id='location-text'>
          <MdLocationOn className="me-1 location-icon" /> {`${vendor.state} | ${vendor.city}`}
        </Card.Text>
        <Card.Text className="mb-2" id='category-text'>
          {business_category}
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default VendorCard;